import { render, staticRenderFns } from "./EventReports.vue?vue&type=template&id=7790b6a9&"
import script from "./EventReports.vue?vue&type=script&lang=js&"
export * from "./EventReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports